// components/DataTable/validation.js

/**
 * @param {Object} column
 * @param {*} value
 * @param {Object} row
 * @returns {string|null}
 */
export function validateColumnValue(column, value, row) {
  /*
   * Required validation
   */
  if (column.required) {
    const isEmpty =
      value === null ||
      value === undefined ||
      value === "" ||
      (column.type === "string" &&
        typeof value === "string" &&
        value.trim() === "");

    if (isEmpty) {
      return column.requiredMessage || `${column.title} الزامی است`;
    }
  }

  /*
   * Number validation
   */
  if (column.type === "number") {
    if (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !Number.isFinite(Number(value))
    ) {
      return `${column.title} باید یک عدد معتبر باشد`;
    }
  }

  /*
   * Boolean validation
   */
  if (column.type === "bool") {
    if (value !== true && value !== false) {
      return `${column.title} باید مقدار Boolean داشته باشد`;
    }
  }

  /*
   * Dropdown validation
   */
  if (column.type === "dropdown") {
    if (
      value !== null &&
      value !== undefined &&
      value !== ""
    ) {
      const dataSource = Array.isArray(column.dataSource)
        ? column.dataSource
        : [];

      const exists = dataSource.some(item => {
        return (
          item &&
          String(item[column.valueField]) === String(value)
        );
      });

      if (!exists) {
        return `${column.title} مقدار انتخاب‌شده نامعتبر است`;
      }
    }
  }

  /*
   * Custom validation
   */
  if (typeof column.validate === "function") {
    const result = column.validate(value, row);

    if (typeof result === "string" && result.trim() !== "") {
      return result;
    }

    if (result === false) {
      return `${column.title} نامعتبر است`;
    }
  }

  return null;
}

/**
 * @param {Array<Object>} columns
 * @param {Object} row
 * @returns {Object}
 */
export function validateRow(columns, row) {
  const errors = {};

  columns.forEach(column => {
    const value = row[column.field];

    const error = validateColumnValue(
      column,
      value,
      row
    );

    if (error) {
      errors[column.field] = error;
    }
  });

  return errors;
}